import CaseStudyPage from "@/pages/portfolio/components/CaseStudyPage";

export default function MobileBusinessCase() {
  return <CaseStudyPage slug="mobile-business-application" />;
}